import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useEvaluators } from '@/hooks/v1';
import type { InputDefaultProps } from '../../../types';
import { EvaluatorSelect } from '@/components/ui/Inputs/EvaluatorSelect';
import { FormItem } from '@/components/ui/Inputs/FormItem';

const { useFormInstance, useWatch } = Form;

export function Evaluator({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	const form = useFormInstance();

	const organizationId = useWatch([fieldName, 'organization_id'], form);
	const companyId = useWatch([fieldName, 'company_id'], form);
	const evaluatorId = useWatch([fieldName, 'evaluator_id'], form);

	const {
		data: evaluators,
		isLoading,
		isFetching,
		isError
	} = useEvaluators({
		organization_id: organizationId,
		company_id: companyId
	});

	function handleEvaluatorSelect(id: string): void {
		form.setFieldValue([fieldName, 'evaluator_id'], id);
	}

	function handleClearEvaluator(): void {
		form.setFieldValue([fieldName, 'evaluator_id'], undefined);
	}

	return (
		<Col xs={24}>
			<FormItem
				fontSize={fontSize}
				isRequired={isRequired}
				title={I18n.get('Evaluator')}
				namePath={[fieldName, 'evaluator_id']}
				errorMessage={I18n.get('Select an evaluator')}
			>
				<EvaluatorSelect
					size="large"
					loading={isFetching}
					evaluators={evaluators}
					evaluatorId={evaluatorId}
					fieldName={[fieldName, 'evaluator_id']}
					handleClearEvaluators={handleClearEvaluator}
					handleSelectEvaluator={handleEvaluatorSelect}
					disabled={isLoading || isFetching || isError || disabled}
				/>
			</FormItem>
		</Col>
	);
}
